import { render, staticRenderFns } from "./ExamsDetailsContent.vue?vue&type=template&id=1f0868e6"
import script from "./ExamsDetailsContent.vue?vue&type=script&lang=js"
export * from "./ExamsDetailsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports